import { Typography } from '@mui/material';
import Log from './Log';
import { log } from './Interfaces';

interface Props {
    logs: log[];
    animate : boolean;
}

const LogTab: React.FC<Props> = ( { logs, animate } ) => {

    if(logs.length === 0) {
        return (
            <Typography variant='h5'>No lead status entries available.</Typography>
        )
    }

  return (
    <>
        {logs.map((log, i) => 
            <Log key={i + log.dateUTC} log={log} delay={5 + i*1} animate={animate} />
        )}
    </>
  )
}

export default LogTab